/* eslint-disable import/prefer-default-export */
export const INITIAL_STATE = {
  timerStarted: false,
  timeNextActionIsAvailable: null,
  remainingTime: null,
};
